import { Action } from "@ngrx/store";
import { ITable } from "@common/models/table";
import { DashboardItem } from "@dashboards/models/dashboard-item";
import { ArrearsTransactionDrillDownParamsModel } from '../models/arrears-transaction-drill-down-params.model';

export const LOAD = '[Arrears Transaction Table Schedule Table] Load';
export const LOAD_COMPLETE = '[Arrears Transaction Table Schedule Table] Load Complete';
export const LOAD_ERROR = '[Arrears Transaction Table Schedule Table] Load Error';
export const CLEAR = '[Arrears Transaction Table Schedule Table] CLEAR';

export class Load implements Action {
  readonly type = LOAD;
  constructor(public widget: DashboardItem, public drillDownModel: ArrearsTransactionDrillDownParamsModel) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: ITable, public widget: DashboardItem) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any, public widget: DashboardItem) { }
}

export class Clear implements Action {
  readonly type = CLEAR;
  constructor(public widget: DashboardItem) { }
}

export type Actions =
  Load |
  LoadComplete |
  LoadError |
  Clear;
